export const COLOR_LOOKUP = {
  hopeful: '#cccc1d',
  sad: '#1b6661',
  connected: '#e2a40a',
  loved: '#8da500',
  overwhelmed: '#250a35',
  resilient: '#f99958',
  angry: '#ea7b73',
  confused: '#350a22',
  discouraged: '#2777AE',
  lost: '#0a380a',
  outraged: '#a55050',
  motivated: '#69a600',
  lonely: '#216884',
  anxious: '#0a2b35',
  stuck: '#35230a',
};

export const TEXT_COLOR_LOOKUP = {
  hopeful: '#222',
  sad: '#ffffff',
  connected: '#222',
  loved: '#222',
  overwhelmed: '#ffffff',
  resilient: '#222',
  angry: '#222',
  confused: '#ffffff',
  discouraged: '#ffffff',
  lost: '#ffffff',
  outraged: '#ffffff',
  motivated: '#222',
  lonely: '#ffffff',
  anxious: '#ffffff',
  stuck: '#ffffff',
};
